/**
 * DashboardLayout — Aurora Glass admin shell.
 *
 * Layout:
 *  ┌──────────────┬────────────────────────────────────┐
 *  │              │  AdminTopbar (h-14)                 │
 *  │  AdminSidebar│────────────────────────────────────┤
 *  │  (260px /    │                                    │
 *  │   64px coll) │  <Outlet /> scrollable content     │
 *  │              │                                    │
 *  └──────────────┴────────────────────────────────────┘
 *
 * The entire shell sits on aurora-page background (fixed radial gradients).
 */
import { useState } from 'react'
import { Outlet }   from 'react-router-dom'
import AdminSidebar from '@/components/ui/Sidebar'
import AdminTopbar  from '@/components/ui/Topbar'

export default function DashboardLayout() {
  const [collapsed, setCollapsed] = useState(false)

  return (
    <div className="aurora-page flex h-screen overflow-hidden">
      {/* ── Sidebar ─────────────────────────────────────────── */}
      <AdminSidebar collapsed={collapsed} onToggle={() => setCollapsed((v) => !v)} />

      {/* ── Main column ─────────────────────────────────────── */}
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <AdminTopbar />

        {/* ── Page content ───────────────────────────────────── */}
        <main className="flex-1 overflow-y-auto px-6 py-6">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
